module.exports = __webpack_public_path__ + "img/cxTrends-11.65a6af22.png";